{
  "name": "@imgly/background-removal-node",
  "version": "1.4.5",
  "description": "Background Removal in NodeJS",
  "resources": "@imgly/background-removal-node",
  "keywords": [
    "background-removal",
    "nodejs",
    "image-segmentation",
    "image-matting",
    "onnx"
  ],
  "repository": {
    "type": "git",
    "url": "git+https://github.com/imgly/background-removal-js.git"
  },
  "license": "SEE LICENSE IN LICENSE.md",
  "author": {
    "name": "IMG.LY GmbH",
    "email": "support@img.ly",
    "url": "https://img.ly"
  },
  "bugs": {
    "email": "support@img.ly"
  },
  "homepage": "https://img.ly/showcases/cesdk/web/background-removal",
  "source": "./src/index.ts",
  "main": "./dist/index.cjs",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "require": "./dist/index.cjs",
      "import": "./dist/index.mjs",
      "types": "./dist/index.d.ts"
    }
  },
  "files": [
    "LICENSE.md",
    "README.md",
    "CHANGELOG.md",
    "ThirdPartyLicenses.json",
    "dist/",
    "bin/"
  ],
  "scripts": {
    "start": "npm run watch",
    "clean": "npx rimraf dist",
    "test": "true",
    "resources": "node ../../scripts/package-resources.mjs",
    "changelog:create": "node ../../scripts/changelog/changelog-create.mjs",
    "changelog:generate": "node ../../scripts/changelog/changelog-generate.mjs",
    "build": "npm run clean && npm run resources && npm run types && npm run changelog:generate && node scripts/build.mjs",
    "types": " npx tsc --declaration --emitDeclarationOnly --declarationDir dist --declarationMap",
    "watch": "npm run clean && npm run resources && npm run changelog:generate && node scripts/watch.mjs",
    "lint": "npx prettier --write .",
    "publish:latest": "npm run build && npm publish --tag latest --access public",
    "publish:next": "npm run build && npm publish --tag next --access public",
    "package:pack": "npm run build && npm pack . --pack-destination ../../releases"
  },
  "dependencies": {
    "onnxruntime-node": "~1.17.0",
    "sharp": "~0.32.4",
    "@types/lodash": "~4.14.195",
    "@types/node": "~20.3.1",
    "@types/ndarray": "~1.0.14",
    "lodash": "~4.17.21",
    "ndarray": "~1.0.19",
    "zod": "~3.21.4"
  },
  "devDependencies": {
    "assert": "~2.0.0",
    "esbuild": "~0.18.18",
    "npm-dts": "~1.3.12",
    "os-browserify": "~0.3.0",
    "path-browserify": "~1.0.1",
    "process": "~0.11.10",
    "stream-browserify": "~3.0.0",
    "ts-loader": "~9.4.3",
    "tslib": "~2.5.3",
    "typescript": "~5.1.6",
    "util": "~0.12.5",
    "webpack": "~5.85.1",
    "webpack-cli": "~5.1.4"
  }
}